import { configureStore } from '@reduxjs/toolkit';

import api from '../core/services/api';
import labs from '../core/services/labs';
import grants from 'core/services/grants';
import customers from '../core/services/customers';
import support from '../core/services/support';
import authorization from '../core/services/authorization';
import data from '../core/services/data';
import cartSlice from '../core/services/cart';

import middleware from './middleware';

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [labs.reducerPath]: labs.reducer,
    [grants.reducerPath]: grants.reducer,
    [support.reducerPath]: support.reducer,
    customers,
    authorization,
    data,
    [cartSlice.name]: cartSlice.reducer,
  },
  middleware,
});
